module.exports = __webpack_public_path__ + "static/map4-f1e19b9c0cf226dbbd1a20982f3c4c70.jpg";